import { useState } from 'react'
import './App.css'
import { Footer } from './components/Footer'
import Header from './components/Header'

function App() {
  const [filter, setFilter] = useState('')
  const [toggle, setToggle] = useState({ completed: false })
  return (
    <div className="grid place-items-center bg-blue-100 h-screen px-6 font-sans">
      {/* <!-- navbar --> */}

      <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
        {/* <!-- header --> */}
        <Header filter={filter} toggle={toggle} setToggle={setToggle} setFilter={setFilter} />
        <hr className="mt-4" />

        {/* <!-- footer --> */}
        <div className="mt-4 text-xs text-gray-500">
          <Footer filter={filter} toggle={toggle} setToggle={setToggle} setFilter={setFilter} />
        </div>
      </div>
    </div>
  )
}

export default App
